import * as React from "react";
import { connect } from "react-redux";
import { selectIsTraderEventRunning } from "../../../selectors/selectTraderEventInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { IdBigCharacter } from "../../generic/big-character/IdBigCharacter";
import { DialogFarmEvent } from "../../generic/farm-event/DialogFarmEvent";
import { TraderEventDetails } from "./TraderEventDetails";
import { TraderEventReward } from "./TraderEventReward";
var _DialogTraderEvent = function (_a) {
    var shouldRender = _a.shouldRender;
    if (shouldRender == undefined) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(DialogFarmEvent, { eventTitleLoca: IdLoca.traderEvent_title, eventDescriptionLoca: IdLoca.traderEvent_desc, eventCharacter: IdBigCharacter.MontgomeryPoints, eventCharacterClassName: "flex__full big-character-flip" },
        React.createElement(TraderEventDetails, null),
        React.createElement(TraderEventReward, null)));
};
var mapState = function (state) { return ({
    shouldRender: selectIsTraderEventRunning(state),
}); };
export var DialogTraderEvent = connect(mapState)(_DialogTraderEvent);



//////////////////
// WEBPACK FOOTER
// ./src/features/trader-event/components/DialogTraderEvent.tsx
// module id = 2956
// module chunks = 3